import { Icon, type IconName } from './Icon';
import { cx } from './ui';
import { useTheme, type ThemeChoice } from '../state/useTheme';

const OPTIONS: Array<{ value: ThemeChoice; icon: IconName; label: string }> = [
  { value: 'light', icon: 'sun', label: 'Light' },
  { value: 'auto', icon: 'theme-auto', label: 'Auto — follows sunrise & sunset' },
  { value: 'dark', icon: 'moon', label: 'Dark' },
];

/** Three-way segmented control. `auto` follows the household's sunrise/sunset (OS as fallback). */
export function ThemeSwitcher() {
  const { choice, setChoice } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex items-center gap-0.5 rounded-md border border-border-subtle bg-surface p-0.5"
    >
      {OPTIONS.map((o) => {
        const active = choice === o.value;
        return (
          <button
            key={o.value}
            role="radio"
            aria-checked={active}
            aria-label={o.label}
            title={o.label}
            onClick={() => setChoice(o.value)}
            className={cx(
              'inline-flex size-9 items-center justify-center rounded-[5px] transition-colors duration-150',
              active
                ? 'bg-[var(--color-accent-dim)] text-accent'
                : 'text-muted hover:bg-surface-high hover:text-secondary',
            )}
          >
            <Icon name={o.icon} size={14} />
          </button>
        );
      })}
    </div>
  );
}
